// oxlint-disable-next-line no-restricted-imports
import { TextInput } from "@mantine/core";

import { colors } from "#app/theme/v2/colors";
import { fontSizes } from "#app/theme/v2/fontSizes";
import { fontWeights } from "#app/theme/v2/fontWeights";
import {
  getInputBackgroundColor,
  getInputErrorBackgroundColor,
  getInputErrorShadow,
  inputBorderColor,
  inputErrorBorderColor,
  inputFocusBorderColor,
  inputRadius,
} from "#app/theme/v2/inputStates";
import { spacing } from "#app/theme/v2/spacing";

import classes from "./InputUnit.module.css";
import { UnitSelect } from "./UnitSelect";

type InputUnitProps = {
  value: string;
  onChange: (value: string) => void;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  placeholder?: string;
  unit: string;
  units: string[];
  onUnitChange: (unit: string) => void;
  disabled?: boolean;
  error?: boolean;
  "aria-label"?: string;
};

const InputUnit = ({
  value,
  onChange,
  onBlur,
  placeholder,
  unit,
  units,
  onUnitChange,
  disabled,
  error,
  "aria-label": ariaLabel,
}: InputUnitProps) => {
  return (
    <TextInput
      value={value}
      onChange={(e) => onChange(e.currentTarget.value)}
      onBlur={onBlur}
      placeholder={placeholder}
      disabled={disabled}
      error={error}
      aria-label={ariaLabel}
      radius={inputRadius}
      rightSectionWidth="auto"
      rightSection={
        <UnitSelect
          unit={unit}
          units={units}
          onUnitChange={onUnitChange}
          disabled={disabled}
          error={error}
        />
      }
      classNames={{ input: classes.input }}
      style={
        {
          "--iu-bg": getInputBackgroundColor({ disabled, hasValue: Boolean(value) }),
          "--iu-bd": inputBorderColor,
          "--iu-color": colors.text.primaryDefault,
          "--iu-placeholder-color": colors.text.secondaryDefault,
          "--iu-fz": fontSizes[14],
          "--iu-fw": fontWeights.regular,
          "--iu-height": spacing[9],
          "--iu-radius": inputRadius,
          "--iu-focus-bd": inputFocusBorderColor,
          "--iu-error-bd": inputErrorBorderColor,
          "--iu-error-bg": getInputErrorBackgroundColor({ hasValue: Boolean(value) }),
          "--iu-error-shadow": getInputErrorShadow({ hasValue: Boolean(value) }),
          "--iu-disabled-color": colors.text.primaryDefault,
          "--iu-disabled-placeholder-color": colors.text.primaryDisabled,
          "--iu-padding-inline-start": spacing[3],
        } as React.CSSProperties
      }
    />
  );
};

export { InputUnit };
